import { CUSAT_PAGE_SIZE } from 'constants/cusat';
import { CusatFilters, CusatSort, CusatState } from './interfaces';

export const storeName = 'cusat';

export const initialFilters: CusatFilters = {
  accountName: null,
  updatedFrom: null,
  updatedTo: null,
};

export const initialSort: CusatSort = {
  sortBy: 'accountName',
  sortOrder: 'ASC',
};

export const cusatInitialState: CusatState = {
  items: [],
  filters: { ...initialFilters },
  sort: { ...initialSort },
  pagination: {
    limit: CUSAT_PAGE_SIZE,
    page: 1,
    total: 0,
  },
  loading: false,
  updating: false,
  exporting: false,
  importing: false,
  init: false,
};
